import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export default function MarketingData(handleSubmitClick) {

    const button = <Button variant="contained" color="primary" onClick={handleSubmitClick}>GET A QUOTE</Button>;
    return [
        {
            text: [
                {
                    icon: <img src="/product-landing/supp/cancer-ribbon.png" className="mb-2" alt=""/>,
                    title: "What is supplemental cancer coverage used for?",
                    paragraphs: ["Cancer Protection Assurance helps with medical expenses associated with a positive diagnosis of cancer. You can also use your benefits to help with travel and lodging for your family, so they can be with you if you need to travel for treatment.",
                        "Cancer treatments can become costly fast, even with health insurance. With supplemental coverage from Aflac, it can help ease stress and financial hardship so you can focus on getting well.",
                        button],
                }
            ]
            ,
            image: "/product-landing/supp/circle2.png"
        }
        ,
        {
            text: [
                {
                    icon: <img src="/product-landing/supp/ambulence.png" className="mb-2" alt=""/>,
                    title: "How is accident insurance different from my health insurance?",
                    paragraphs: ["Accident insurance helps with things that health insurance may not cover, like your mortgage payment, food for your family, and other medical and living expenses. You won't have deductible or copays. We pay cash benefits directly to you (unless otherwise assigned) to be used however you choose.",
                        "You are free to choose your medical providers. Accidents happen. Financial hardship doesn't have to. We pay you cash benefits in the event of a covered injury, so you can focus on recovery instead of your finances.",
                        button],
                }
            ]
            ,
            image: "/product-landing/supp/circle3.png"
        },
        {
            text: [
                {
                    icon: <img src="/product-landing/supp/heartbeat.png" className="mb-2" alt=""/>,
                    title: "What is critical illness insurance used for?",
                    paragraphs: ["In the event of a major illness, your health insurance will only go so far. Aflac critical illness can help with the treatment costs of life-changing illnesses and health events, so you can stay focused on recuperation.",
                        "Aflac helps with things associated with critical illnesses. You can also use the cash benefits to help with other non-medical things, like rent, food, bills, and childcare.",
                        button],
                }
            ]
            ,
            image: "/product-landing/supp/circle4.png"
        }
    ]
}

MarketingData.propTypes = {
    quoterUrl: PropTypes.string.isRequired
}